module.exports = __webpack_public_path__ + "static/media/clock-regular.891b3563.svg";